"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BasePriceBlock = _interopRequireDefault(require("./BasePriceBlock"));
const messages = {
  percentageSavings: 'pricing.savePercent',
  moneySavings: 'pricing.saveMoney'
};
const TwoLinePriceBlock = ({
  domain,
  product,
  options = {},
  enableDynamicFontScaling = false,
  language,
  portalElem
}) => {
  const {
    Fqdn
  } = domain;
  const datacy = `${Fqdn}_price`;
  return /*#__PURE__*/_react.default.createElement(_BasePriceBlock.default, {
    datacy,
    options: {
      ...options,
      showTwoLinePrice: true
    },
    domain,
    product,
    messages,
    enableDynamicFontScaling,
    language,
    portalElem
  });
};
TwoLinePriceBlock.propTypes = {
  language: _propTypes.default.object.isRequired,
  domain: _propTypes.default.object.isRequired,
  product: _propTypes.default.object.isRequired,
  options: _propTypes.default.object,
  enableDynamicFontScaling: _propTypes.default.bool,
  portalElem: _propTypes.default.object
};
var _default = exports.default = TwoLinePriceBlock;